import { Reveal } from "@/components/Reveal";

export const SectionHead = ({ overline, title, sub, dark = false }) => (
    <div className="max-w-3xl">
        <Reveal>
            <p className="flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.3em] text-[#F16622]">
                <span className="inline-block h-px w-10 bg-[#F16622]" />
                {overline}
            </p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className={`font-display mt-6 text-3xl font-medium leading-[1.08] tracking-tight sm:text-4xl lg:text-5xl ${dark ? "text-white" : "text-[#0F172A]"}`}>
                {title}
            </h2>
        </Reveal>
        {sub && (
            <Reveal delay={0.16}>
                <p className={`mt-6 text-base leading-relaxed md:text-lg ${dark ? "text-white/60" : "text-slate-600"}`}>{sub}</p>
            </Reveal>
        )}
    </div>
);
